import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { HttpClientModule } from '@angular/common/http'
import { FormsModule } from '@angular/forms';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireModule } from '@angular/fire';
import { GLOBAL } from './services/global.service';
import { routing } from './app.routing';
import { InicioComponent } from './components/inicio/inicio.component';
import { LoginComponent } from './components/login/login.component';
import { FooterComponent } from './components/footer/footer.component';
import { NoticiasComponent } from './components/noticias/noticias.component';
import { AgendaComponent } from './components/agenda/agenda.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { FlatpickrModule } from 'angularx-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';
import 'flatpickr/dist/flatpickr.css';
import { InformesPlenariaComponent } from './components/informes-plenaria/informes-plenaria.component';
import { ParlacenTvComponent } from './components/parlacen-tv/parlacen-tv.component';
import { MemberComponent } from './components/member/member.component';
import { UsersComponent } from './components/users/users.component';
import { DiputadosComponent } from './components/diputados/diputados.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    InicioComponent,
    LoginComponent,
    FooterComponent,
    NoticiasComponent,
    AgendaComponent,
    InformesPlenariaComponent,
    ParlacenTvComponent,
    MemberComponent,
    UsersComponent,
    DiputadosComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    routing,
    NgbModule,
    AngularFireModule.initializeApp(GLOBAL.firebaseConfig),
    AngularFireStorageModule,
    FormsModule,
    NgbModalModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    FlatpickrModule.forRoot({ locale: Spanish }),
  ],
  exports: [
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
